import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { environment } from '../../../../../environments/environment';

import { TrendingFacetsModel } from '../../models';

@Injectable({
  providedIn: 'root',
})
export class AlgoliaAnalyticsService {
  readonly algoliaBaseUrl: string = `https://analytics.us.algolia.com`;

  private httpOptions: any = {};
  private indexName: string = environment.algolia.listingIndexName;

  constructor(private httpClient: HttpClient) {
    this.createHttpOptions();
  }

  public createHttpOptions(): void {
    this.httpOptions = {
      headers: new HttpHeaders({
        'X-Algolia-Application-Id': environment.algolia.appId,
        'X-Algolia-API-Key': environment.algolia.searchAPIKey,
      }),
    };
  }

  public getTrending(facetValue: string, limit = 10): Observable<any> {
    const url = `${this.algoliaBaseUrl}/2/filters/${facetValue}?index=${this.indexName}&limit=${limit}`;
    return this.httpClient.get<TrendingFacetsModel>(url, this.httpOptions);
  }

  public getTrendingHits(limit = 10): Observable<any> {
    const url = `${this.algoliaBaseUrl}/2/hits?index=${this.indexName}&limit=${limit}`;
    return this.httpClient.get(url, this.httpOptions);
  }

  public sendUserInsights(
    eventName: string,
    userId: string,
    objectId: string
  ): void {
    const url = 'https://insights.algolia.io/1/events';
    const config = {
      events: [
        {
          eventType: 'view',
          userToken: userId,
          eventName: eventName,
          timestamp: Date.now(),
          index: environment.algolia.listingIndexName,
          objectIDs: [objectId],
        },
      ],
    };
    this.httpClient
      .post(url, JSON.stringify(config), this.httpOptions)
      .subscribe();
  }
}
